import {
  IlogisticServiceDetailsDeliveryCollectionData,
  IlogisticServiceDetailsToolsData,
  LOCATION_PLACE_TYPE
} from '../../../../../../../types/services';

/**
 * Reemplaza el placeholder de ubicación de origen en un texto usando el tipo de lugar, nombre del entregador y país del teléfono del entregador
 * @param place - Tipo de lugar de origen
 * @param collectionInfo - Información de recolección que contiene los detalles del entregador
 * @returns Texto con el placeholder de ubicación de origen reemplazado o un string vacío si no se encuentra el lugar
 */
export const replaceOriginLocationPlaceholder = (
  place?: string | null,
  collectionInfo?: IlogisticServiceDetailsDeliveryCollectionData | null
): string => {
  if (!collectionInfo || !place) return '';
  
  const { delivererName, delivererCountryPhone } = collectionInfo;
  if (place === LOCATION_PLACE_TYPE.USER) return delivererName || '';
  if (place === LOCATION_PLACE_TYPE.OFFICE) return `Oficinas ${delivererName || ''}`;
  if (place === LOCATION_PLACE_TYPE.NUDOS) return `Bodegas ${delivererCountryPhone?.name || ''}`;
  return '';  
};


export interface ISeparateTools  {
  deliveredRegularTools: IlogisticServiceDetailsToolsData[];
  deliveredAdditionalTools: IlogisticServiceDetailsToolsData[];
  notDeliveredRegularTools: IlogisticServiceDetailsToolsData[];
  notDeliveredAdditionalTools: IlogisticServiceDetailsToolsData[];
}
/**
 * Separa las herramientas en cuatro grupos según su estado de entrega y si son productos adicionales
 * @param tools - Array de herramientas a separar
 * @returns Objeto que contiene cuatro grupos de herramientas: entregadas regulares, entregadas adicionales, no entregadas regulares y no entregadas adicionales
 */
export const separateTools = (tools: IlogisticServiceDetailsToolsData[]): ISeparateTools => {
  const deliveredTools = tools.filter(tool => !tool.isMarkedNotDelivered);
  const notDeliveredTools = tools.filter(tool => tool.isMarkedNotDelivered);

  return {
    deliveredRegularTools: deliveredTools.filter(tool => !tool.isAdditionalProduct),
    deliveredAdditionalTools: deliveredTools.filter(tool => tool.isAdditionalProduct),
    notDeliveredRegularTools: notDeliveredTools.filter(tool => !tool.isAdditionalProduct),
    notDeliveredAdditionalTools: notDeliveredTools.filter(tool => tool.isAdditionalProduct)
  };
};

export interface ISectionsTexts {
  deliveredSectionTitle: string;
  additionalDeliveredSectionTitle: string;
  notDeliveredSectionTitle: string;
  additionalNotDeliveredSectionTitle: string;
  notDeliveredNotificationMessage: string;
}
/**
 * Obtiene los títulos de las secciones y mensajes de notificación según el estado de entrega del servicio
 * @param isDelivered - Si el estado del servicio logístico es entregado
 * @param originLocationText - Texto que representa la ubicación de origen
 * @returns Objeto que contiene los títulos de las secciones y mensajes de notificación para herramientas entregadas y no entregadas
 */
export const getSectionsTexts = (isDelivered: boolean, originLocationText: string): ISectionsTexts => {
  if (isDelivered) {
    return {
      deliveredSectionTitle: 'Herramientas entregadas',
      additionalDeliveredSectionTitle: 'Herramientas adicionales',
      notDeliveredSectionTitle: 'Herramientas no entregadas',
      additionalNotDeliveredSectionTitle: 'Herramientas adicionales no entregadas',
      notDeliveredNotificationMessage: `Estas herramientas <strong>no fueron entregadas</strong> y permanecieron en su ubicación anterior: ${originLocationText}`
    };
  }

  return {
    deliveredSectionTitle: 'Herramientas que serán entregadas',
    additionalDeliveredSectionTitle: 'Herramientas adicionales',
    notDeliveredSectionTitle: 'Herramientas que no serán entregadas',
    additionalNotDeliveredSectionTitle: 'Herramientas adicionales que no serán entregadas',
    notDeliveredNotificationMessage: `Estas herramientas <strong>no serán entregadas</strong> y permanecerán en su ubicación anterior: ${originLocationText}`
  };
};

